import React, { useEffect, useRef } from 'react';

const MicIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/>
    <path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/>
    <line x1="8" y1="23" x2="16" y2="23"/>
  </svg>
);

const LyricsPanel = ({ lyricsState, artist, title, onDismiss }) => {
  const isLoading = lyricsState === 'loading';
  const result    = lyricsState && lyricsState !== 'loading' ? lyricsState : null;
  const lyricsRef = useRef(null);

  // Scroll lyrics to top whenever a new result arrives
  useEffect(() => {
    if (result?.lyrics && lyricsRef.current) {
      lyricsRef.current.scrollTop = 0;
    }
  }, [result]);

  if (!isLoading && !result) return null;

  return (
    <>
      <div className="ip-backdrop" onClick={onDismiss} aria-hidden="true" />

      <aside className="identify-panel lyrics-panel" role="dialog" aria-modal="true" aria-label="Song lyrics">
        {/* Header */}
        <div className="ip-header">
          <div className="ip-header-title">
            <MicIcon />
            <span>Lyrics</span>
          </div>
          <button className="ip-close" onClick={onDismiss} aria-label="Close">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>

        {/* Song context */}
        {(title || artist) && (
          <div className="ip-context">
            <span className="lp-song-title">{title}</span>
            {artist && <span className="lp-song-artist"> — {artist}</span>}
          </div>
        )}

        {/* Loading */}
        {isLoading && (
          <div className="ip-loading">
            <div className="lp-loading-icon">
              <MicIcon />
            </div>
            <p className="ip-loading-text">Fetching lyrics…</p>
            <p className="ip-loading-sub">Looking up from lyrics.ovh</p>
          </div>
        )}

        {/* Not found */}
        {result && !result.lyrics && (
          <div className="ip-notfound">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/>
            </svg>
            <p className="ip-notfound-title">Lyrics not found</p>
            <p className="ip-notfound-sub">
              We couldn't find lyrics for <strong>{title}</strong>
              {artist ? ` by ${artist}` : ''}. This song may not be in the lyrics.ovh database yet.
            </p>
          </div>
        )}

        {/* Found — lyrics text */}
        {result && result.lyrics && (
          <div className="lp-lyrics-wrap" ref={lyricsRef}>
            <div className="lp-lyrics-text">
              {result.lyrics.split('\n').map((line, i) => (
                line.trim() === ''
                  ? <div key={i} className="lp-lyric-gap" />
                  : <p key={i} className="lp-lyric-line">{line}</p>
              ))}
            </div>
            <p className="lp-attribution">Lyrics provided by <a href="https://lyrics.ovh" target="_blank" rel="noopener noreferrer">lyrics.ovh</a></p>
          </div>
        )}
      </aside>
    </>
  );
};

export default LyricsPanel;
